import React from "react";
import { RCCBadge } from "react-common-components";
import IComponentBadge from "react-common-components/dist/components/Badge/interface";
import { useTranslation } from "src/context/Translations/context";
import { IKanbanType } from "../interface";

export interface IBadgeKanbanType{
  type: IKanbanType;
	styleInline?: string;
}

const BadgeKanbanType: React.FC<IBadgeKanbanType> = ({
	type,
	styleInline
}) => {

	const { translate } = useTranslation();

	const colorAndText = (() => {
		let color: IComponentBadge["color"];
		let text: string = "";
		switch (type) {
		case IKanbanType.ACTIONS:
			color = "green";
			text = translate("Ações");
			break; 
		case IKanbanType.PROJECT:
			color = "blue";
			text = translate("Projetos");
			break; 
		default:
			color = undefined;
			text = "";
			break; 
		}
		return {color, text};
	})();

	return (
		<>
			<RCCBadge 
				color={colorAndText.color}
				styleInline={`padding: 2px 8px; font-size: 0.78rem;${styleInline}`}
			>
				{colorAndText.text}
			</RCCBadge>
		</>
	);
};

export default BadgeKanbanType;
